import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Testimonials() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const navigate = useNavigate();

  const testimonials = [
    {
      name: 'Marc Dubois',
      company: 'Menuiserie Dubois - Lyon',
      image: 'https://public.readdy.ai/ai/img_res/3b6433ffa322bcae8fa5489fb4a44853.jpg',
      rating: 5,
      text: 'Depuis que j\'achète des leads ici, mon CA a augmenté de 40%. Les clients sont vraiment qualifiés et prêts à signer. J\'ai converti 8 leads sur 10 le mois dernier !',
      revenue: '+12 000€ en 3 mois',
      stats: {
        leadsAchetes: 47,
        tauxConversion: '85%',
        tempsEconomise: '15h/semaine'
      },
      experience: '6 mois d\'utilisation'
    },
    {
      name: 'Sophie Martin',
      company: 'Fenêtres & Volets Martin - Bordeaux',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20businesswoman%20window%20company%20owner%20smiling%20confident%20portrait%20wearing%20business%20casual%20attire%20in%20modern%20office%20professional%20headshot%20bright%20natural%20lighting&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'Fini la prospection qui ne mène nulle part ! Chaque lead est une vraie opportunité. Le retour sur investissement est incroyable, je recommande à 100%.',
      revenue: '+8 500€ en 2 mois',
      stats: {
        leadsAchetes: 32,
        tauxConversion: '78%',
        tempsEconomise: '20h/semaine'
      },
      experience: '4 mois d\'utilisation'
    },
    {
      name: 'Thomas Leroy',
      company: 'Réparation Express - Paris',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20technician%20window%20repair%20specialist%20young%20man%20smiling%20confident%20portrait%20wearing%20work%20clothes%20with%20company%20logo%20professional%20headshot%20bright%20natural%20lighting&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'Les leads sont exclusifs et les coordonnées sont toujours exactes. J\'ai pu développer mon activité sans embaucher de commercial. C\'est parfait pour les artisans !',
      revenue: '+15 000€ en 4 mois',
      stats: {
        leadsAchetes: 58,
        tauxConversion: '82%',
        tempsEconomise: '25h/semaine'
      },
      experience: '8 mois d\'utilisation'
    },
    {
      name: 'Jean-Luc Moreau',
      company: 'Alu Concept - Lille',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20aluminum%20window%20specialist%20mature%20man%20confident%20smile%20wearing%20safety%20glasses%20and%20work%20uniform%20in%20modern%20workshop%20bright%20lighting%20portrait&width=200&height=200&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'En 3 mois, j\'ai récupéré 10 fois mon investissement ! Les leads sont de qualité premium, avec des budgets réels. Ma femme peut enfin m\'aider à gérer les rendez-vous.',
      revenue: '+22 000€ en 5 mois',
      stats: {
        leadsAchetes: 73,
        tauxConversion: '79%',
        tempsEconomise: '18h/semaine'
      },
      experience: '5 mois d\'utilisation'
    },
    {
      name: 'Amélie Rousseau',
      company: 'Baies & Fenêtres 31 - Toulouse',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20female%20entrepreneur%20window%20business%20owner%20confident%20smile%20wearing%20business%20attire%20in%20modern%20showroom%20with%20window%20displays%20bright%20natural%20lighting%20portrait&width=200&height=200&seq=testimonial-005&orientation=squarish',
      rating: 5,
      text: 'J\'étais sceptique au début, mais les résultats parlent ! Plus besoin de faire du porte-à-porte. Je me concentre sur mon métier et les clients viennent naturellement.',
      revenue: '+18 500€ en 6 mois',
      stats: {
        leadsAchetes: 65,
        tauxConversion: '88%',
        tempsEconomise: '22h/semaine'
      },
      experience: '6 mois d\'utilisation'
    },
    {
      name: 'Patrick Legrand',
      company: 'Volets & Stores Legrand - Nice',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20shutter%20specialist%20middle%20aged%20man%20smiling%20confident%20portrait%20wearing%20polo%20shirt%20in%20workshop%20with%20shutters%20and%20tools%20bright%20lighting%20professional%20headshot&width=200&height=200&seq=testimonial-006&orientation=squarish',
      rating: 5,
      text: 'Mes concurrents galèrent encore avec la prospection traditionnelle pendant que moi je décroche des chantiers premium tous les jours. C\'est un avantage concurrentiel énorme !',
      revenue: '+16 800€ en 4 mois',
      stats: {
        leadsAchetes: 52,
        tauxConversion: '81%',
        tempsEconomise: '16h/semaine'
      },
      experience: '7 mois d\'utilisation'
    }
  ];

  // Statistiques globales
  const globalStats = {
    totalClients: 247,
    satisfactionRate: 96,
    averageROI: 640,
    totalRevenue: 1250000,
    averageConversionRate: 82,
    totalLeadsSold: 3420
  };

  const handleNavigateToInscription = () => {
    navigate('/inscription-candidat');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Statistiques Globales */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-trophy-line text-green-600"></i>
            Résultats Certifiés
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ils Ont Transformé Leur Activité
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            Découvrez les résultats concrets obtenus par nos {globalStats.totalClients} clients actifs
          </p>

          {/* Statistiques impressionnantes */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-3xl p-6 border border-blue-100">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">{globalStats.totalClients}+</div>
              <div className="text-sm font-medium text-gray-600">Professionnels Actifs</div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-6 border border-green-100">
              <div className="text-3xl md:text-4xl font-bold text-green-600 mb-2">{globalStats.satisfactionRate}%</div>
              <div className="text-sm font-medium text-gray-600">Taux de Satisfaction</div>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-6 border border-teal-100">
              <div className="text-3xl md:text-4xl font-bold text-teal-600 mb-2">{globalStats.averageConversionRate}%</div>
              <div className="text-sm font-medium text-gray-600">Conversion Moyenne</div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-6 border border-blue-100">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">+{globalStats.averageROI}%</div>
              <div className="text-sm font-medium text-gray-600">ROI Moyen</div>
            </div>
          </div>
        </div>

        {/* Témoignage Principal Interactif */}
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-8 md:p-12 border border-gray-200 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-lg flex-shrink-0">
                  <img 
                    src={testimonials[activeTestimonial].image}
                    alt={testimonials[activeTestimonial].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-xl text-gray-900">{testimonials[activeTestimonial].name}</div>
                  <div className="text-gray-600">{testimonials[activeTestimonial].company}</div>
                  <div className="text-sm text-blue-600 font-medium">{testimonials[activeTestimonial].experience}</div>
                </div>
              </div>

              <div className="flex gap-1 mb-6">
                {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>

              <blockquote className="text-lg text-gray-700 leading-relaxed mb-6 italic">
                "{testimonials[activeTestimonial].text}"
              </blockquote>

              <div className="bg-white rounded-2xl p-6 border border-blue-200">
                <div className="text-sm text-gray-600 mb-2">Résultat Financier</div>
                <div className="text-3xl font-bold text-blue-600 mb-4">{testimonials[activeTestimonial].revenue}</div>
                
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-2xl font-bold text-gray-900">{testimonials[activeTestimonial].stats.leadsAchetes}</div>
                    <div className="text-xs text-gray-500">Leads Achetés</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-green-600">{testimonials[activeTestimonial].stats.tauxConversion}</div>
                    <div className="text-xs text-gray-500">Conversion</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-teal-600">{testimonials[activeTestimonial].stats.tempsEconomise}</div>
                    <div className="text-xs text-gray-500">Temps Gagné</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sélecteur de témoignages */}
            <div className="space-y-3">
              {testimonials.map((testimonial, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTestimonial(index)}
                  className={`w-full text-left p-4 rounded-2xl transition-all cursor-pointer border ${
                    activeTestimonial === index
                      ? 'bg-white border-blue-300 shadow-lg'
                      : 'bg-white/50 border-gray-200 hover:bg-white hover:border-blue-200'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow">
                      <img 
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-gray-900 truncate">{testimonial.name}</div>
                      <div className="text-sm text-gray-600 truncate">{testimonial.company.split(' - ')[0]}</div>
                      <div className="text-sm font-bold text-blue-600">{testimonial.revenue}</div>
                    </div>
                    {activeTestimonial === index && (
                      <i className="ri-check-line text-blue-600 text-xl"></i>
                    )}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Grille de témoignages compacts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {testimonials.slice(0, 6).map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-all duration-300 hover:border-blue-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-500">{testimonial.company.split(' - ')[1]}</div>
                </div>
              </div>

              <div className="flex gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>

              <p className="text-sm text-gray-700 leading-relaxed mb-4 line-clamp-3">
                "{testimonial.text}"
              </p>

              <div className="flex justify-between items-center text-sm">
                <span className="font-bold text-blue-600">{testimonial.revenue}</span>
                <span className="text-green-600 font-medium">{testimonial.stats.tauxConversion} conversion</span>
              </div>
            </div>
          ))}
        </div>

        {/* Section Preuves Supplémentaires */}
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12 text-white mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">En Chiffres : Notre Impact</h3>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Des résultats mesurables qui parlent d'eux-mêmes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-blue-400 mb-2">
                {(globalStats.totalRevenue / 1000000).toFixed(1)}M€
              </div>
              <div className="text-gray-300">Revenus Générés</div>
              <div className="text-sm text-blue-300 mt-2">Pour nos clients en 2024</div>
            </div>
            
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-green-400 mb-2">
                {globalStats.totalLeadsSold}+
              </div>
              <div className="text-gray-300">Leads Vendus</div>
              <div className="text-sm text-green-300 mt-2">Depuis notre création</div>
            </div>
            
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-400 mb-2">2,8</div>
              <div className="text-gray-300">Semaines Moyennes</div>
              <div className="text-sm text-teal-300 mt-2">Pour récupérer l'investissement</div>
            </div>
          </div>
        </div>

        {/* Call-to-action final */}
        <div className="bg-gradient-to-br from-blue-600 to-teal-600 rounded-3xl p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Prêt à Rejoindre Nos {globalStats.totalClients}+ Clients Satisfaits ?</h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Accédez dès maintenant à des leads exclusifs et commencez à développer votre activité comme eux
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={handleNavigateToInscription}
              className="bg-white text-blue-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-50 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer transform hover:scale-105 shadow-xl group"
            >
              Demander l'Accès Membre
              <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
            </button>
            <div className="text-blue-200 text-sm">
              <i className="ri-shield-check-line mr-2"></i>
              Satisfait ou remboursé sous 30 jours
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
